import styled from 'styled-components';
import * as React from 'react';
import { ellipsisText } from '../util/style/ellipsis-text.util';

// TODO2024 - remove @ts-ignore
// @ts-ignore
const Span = styled.span`
  ${(props: { isEllipsis: boolean }) => props.isEllipsis ? ellipsisText : ''};
`;

export interface IEllipsisProps {
  children: string;
  isEllipsis?: boolean;
  style?: React.CSSProperties;
  onClick?: () => void;
  title?: string;
}

export const Ellipsis = (props: IEllipsisProps) => (
  <Span {...props} isEllipsis={props.isEllipsis === undefined || props.isEllipsis}>
        {props.children}
    </Span>
);
